import { withNavigationErrorHandler } from "@angular/router";

import type { NavigationError } from "@angular/router";

const STALE_CHUNK_PATTERN =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|ChunkLoadError|Loading chunk/;
const RELOAD_KEY = "stale-chunk-reload-at";
const RELOAD_WINDOW_MS = 10_000;

export function isStaleChunkError(error: unknown): boolean {
  const message =
    error instanceof Error ? `${error.name} ${error.message}` : String(error ?? "");
  return STALE_CHUNK_PATTERN.test(message);
}

export function reloadOnStaleChunk(
  event: Pick<NavigationError, "error" | "url">,
  storage: Pick<Storage, "getItem" | "setItem"> = sessionStorage,
  location: Pick<Location, "assign"> = window.location,
  now: number = Date.now(),
): boolean {
  if (!isStaleChunkError(event.error)) return false;
  const lastReload = Number(storage.getItem(RELOAD_KEY) ?? 0);
  if (now - lastReload < RELOAD_WINDOW_MS) return false;
  storage.setItem(RELOAD_KEY, String(now));
  location.assign(event.url);
  return true;
}

export function withStaleChunkReload() {
  return withNavigationErrorHandler((event) => {
    reloadOnStaleChunk(event);
  });
}
